import React, { PureComponent } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import styles from "./FicheClient.local.scss";
import _ from "i18n";
import EmbeddedPage from "../Dashboard/EmbeddedPage";
import ContentListPresentation from "./ContentListPresentation";
import {
  fetchPresentation,
  fetchDashboard,
  fetchAnnexeList,
  fetchFicheClient
} from "Thunks";
import { setCurrentNavPage } from "Actions";
import HeaderFicheClient from "./HeaderFicheClient";
import NotFoundV2 from "../NotFound/NotFoundV2";
import PresentationListFetching from "./PresentationListFetching";
import { push } from "react-router-redux";

class FicheClient extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedMailingYear: "",
      year: this.props.year || new Date().getFullYear(),
      years: [],
      accountingDates: [],
      dataYear: [],
      dashboardId: 27,
      yearDivIsVisible: false
    };
  }
  componentDidMount() {
    const { dispatch, uen } = this.props;
    const { dashboardId } = this.state;
    dispatch(fetchPresentation(uen, "ALL"));
    dispatch(setCurrentNavPage("FICHE_CLIENT"));
    dispatch(fetchDashboard(null, uen, null, dashboardId));
    dispatch(fetchAnnexeList(uen));
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleSelectYear = year => {
    const { dispatch, uen } = this.props;
    const { dashboardId } = this.state;
    this.setState({
      year: year,
      yearDivIsVisible: false
    });
    dispatch(fetchDashboard(year, uen, null, dashboardId));
  };

  handleClickOutsideYearSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }

  handlePrepareAccountingDateYear = (accountingDates, data) => {
    const { year } = this.state;
    let newYear = accountingDates
      ? accountingDates[0] && accountingDates[0].year
      : "";
    let accountingDateYear =
      Array.isArray(data) && data.filter(item => item.period === year + "")[0];
    this.setState({
      year: year === "" ? newYear : year,
      accountingDates: accountingDates,
      dataYear: accountingDateYear
    });
  };

  handleError = () => {
    const { error } = this.props;

    if (error.code === 170043) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"noBalanceImportedMessage"}
          isBalancePage={true}
          buttonIgnored={1}
        />
      );
    } else if (error.code === 170060) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={`${_("accessDenied")} : ${_("dashboardNotFound")}`}
          buttonIgnored={1}
        />
      );
    } else {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"errorOccured"}
          buttonIgnored={1}
        />
      );
    }
  };
  handleChangeYear = value => {
    const { dispatch, synchro, uen } = this.props;
    const { dashboardId } = this.state;
    this.setState({
      year: value
    });
    dispatch(fetchFicheClient(uen, synchro, value));
    dispatch(fetchDashboard(value, uen, null, dashboardId));
    dispatch(fetchPresentation(uen, value));
    dispatch(push(`/fiche-client/${uen}/${value}`));
  };

  render() {
    const {
      organizations,
      uen,
      data,
      annexes,
      dashboard,
      error,
      fetchingDashboard,
      fetchingPresentations,
      fetchedPresentations
    } = this.props;
    const { dashboardId, year } = this.state;
    let organization =
      organizations.filter(item => item.organization.uen === uen)[0] &&
      organizations.filter(item => item.organization.uen === uen)[0];
    let accountingDates = organization && organization.accountingDates;
    let organizationModel = organization && organization.dashboard.label;
    let years = [];
    accountingDates && accountingDates.forEach(item => years.push(item.year));

    this.handlePrepareAccountingDateYear(accountingDates, data);

    return (
      <div
        style={{
          backgroundColor: "#FAFBFB",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          minHeight: 800
        }}
      >
        <HeaderFicheClient
          currentPage="FICHECLIENT"
          organization={organization}
          dashboardId={dashboardId}
          years={years}
          selectedYear={year}
          handleChangeYear={value => this.handleChangeYear(value)}
        />
        <div
          className={styles.body}
          // style={{ padding: withoutHeader ? "0px 0px 0px 40px" : "" }}
        >
          <div className={classnames(styles.content)}>
            {error &&
              !fetchingDashboard &&
              !fetchingPresentations &&
              this.handleError()}

            {!error && (
              <div style={{ display: "flex" }}>
                <div className={classnames("large-7 medium-7 small-7")}>
                  <div
                    className={classnames(
                      "large-12 medium-12 small-12",
                      styles.statistics
                    )}
                  >
                    <div className={styles.tabs}>
                      <div>
                        <div className={styles.header_statistics}>
                          <div className={styles.title}>
                            {_("inSomeFigures")}
                          </div>
                        </div>
                        <div className={styles.content}>
                          <div className={styles.statistics_body}>
                            {dashboard &&
                              dashboard.id === dashboardId && (
                                <EmbeddedPage
                                  uen={uen}
                                  id={dashboardId}
                                  embeddedStyle={true}
                                />
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classnames("large-5 medium-5 small-5")}>
                  <div className={styles.tabs}>
                    <div className={styles.presentations_body}>
                      {fetchingPresentations && <PresentationListFetching />}
                      {!fetchingPresentations &&
                        fetchedPresentations && (
                          <ContentListPresentation
                            organizationUen={uen}
                            organization={organization}
                            organizationModel={organizationModel}
                            accountingDates={accountingDates}
                            lng={this.props.lng}
                            data={data}
                            annexes={annexes}
                            selectedYear={year}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchingDashboard: state.dashboard.fetching,
  fetched: state.dashboard.fetched,
  fetchingPresentations:
    state.presentation.fetching || state.annexes.annexesList.fetching,
  fetchedPresentations:
    state.presentation.fetched && state.annexes.annexesList.fetched,
  dashboard: state.dashboard.data,
  error: state.dashboard.error,
  organizations: state.organizations.list.items,
  annexes: state.annexes.annexesList.items,
  lng: state.params.lng,
  data: state.presentation.data,
  withoutHeader: state.auth.withoutHeader,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro
});

export default connect(mapStateToProps)(FicheClient);



// WEBPACK FOOTER //
// ./src/components/FicheClient/FicheClient.js